import {
	type AdminCharacter,
	type AdminLocation,
	type AdminSeriesBible,
	type AdminSeriesDetail,
	type AdminSeriesList,
	type AdminSeriesSummary,
	type CoverUploadResponse,
	type CreateCharacterInput,
	type CreateLocationInput,
	type CreateSeriesInput,
	coverUploadResponseSchema,
	type UpdateCharacterInput,
	type UpdateLocationInput,
	type UpdateSeriesInput,
	type UpsertSeriesBibleInput,
} from "@storyline/shared";
import { env } from "@/src/common/constants/env";
import { unwrap } from "@/src/common/services/api-error";
import { putBinary } from "@/src/common/services/binary-upload.service";
import { httpClient, request } from "@/src/common/services/http.service";

export const listSeries = async (): Promise<AdminSeriesList> => unwrap(await request(() => httpClient.admin.series.get()));

export const createSeries = async (body: CreateSeriesInput): Promise<AdminSeriesSummary> =>
	unwrap(await request(() => httpClient.admin.series.post(body)));

export const getSeries = async (id: string): Promise<AdminSeriesDetail> =>
	unwrap(await request(() => httpClient.admin.series({ id }).get()));

export const updateSeries = async (id: string, body: UpdateSeriesInput): Promise<AdminSeriesSummary> =>
	unwrap(await request(() => httpClient.admin.series({ id }).put(body)));

export const deleteSeries = async (id: string): Promise<void> => {
	unwrap(await request(() => httpClient.admin.series({ id }).delete()));
};

export const uploadSeriesCover = async (id: string, file: File): Promise<CoverUploadResponse> => {
	const response = await putBinary(`${env.SERVER_URL}/admin/series/${id}/cover`, file);
	return coverUploadResponseSchema.parse(await response.json());
};

export const upsertSeriesBible = async (id: string, body: UpsertSeriesBibleInput): Promise<AdminSeriesBible> =>
	unwrap(await request(() => httpClient.admin.series({ id }).bible.put(body)));

export const setSeriesBibleLock = async (id: string, locked: boolean): Promise<AdminSeriesBible> =>
	unwrap(await request(() => httpClient.admin.series({ id }).bible.lock.put({ locked })));

export const createCharacter = async (seriesId: string, body: CreateCharacterInput): Promise<AdminCharacter> =>
	unwrap(await request(() => httpClient.admin.series({ id: seriesId }).characters.post(body)));

export const updateCharacter = async (characterId: string, body: UpdateCharacterInput): Promise<AdminCharacter> =>
	unwrap(await request(() => httpClient.admin.characters({ characterId }).put(body)));

export const deleteCharacter = async (characterId: string): Promise<void> => {
	unwrap(await request(() => httpClient.admin.characters({ characterId }).delete()));
};

export const createLocation = async (seriesId: string, body: CreateLocationInput): Promise<AdminLocation> =>
	unwrap(await request(() => httpClient.admin.series({ id: seriesId }).locations.post(body)));

export const updateLocation = async (locationId: string, body: UpdateLocationInput): Promise<AdminLocation> =>
	unwrap(await request(() => httpClient.admin.locations({ locationId }).put(body)));

export const deleteLocation = async (locationId: string): Promise<void> => {
	unwrap(await request(() => httpClient.admin.locations({ locationId }).delete()));
};
